module.exports = __webpack_public_path__ + "img/content3.664fe268.png";